<script lang="ts">
  import type { Persona } from "$lib/stores/me.svelte";

  let { value = $bindable<Persona>("personal") } = $props<{ value?: Persona }>();

  type Card = { id: Persona; emoji: string; title: string; desc: string };
  const cards: Card[] = [
    { id: "personal", emoji: "🙂", title: "Pessoal", desc: "Eu, comigo mesmo. Foco em controle pessoal." },
    { id: "family",   emoji: "👨‍👩‍👧", title: "Família", desc: "Compartilhado com cônjuge ou família." },
    { id: "business", emoji: "💼", title: "Negócio",  desc: "PF + PJ separados, com privacidade extra." },
  ];
</script>

<div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
  {#each cards as c}
    <button
      type="button"
      class="persona-card"
      class:selected={value === c.id}
      aria-pressed={value === c.id}
      onclick={() => (value = c.id)}
    >
      <div class="text-3xl mb-1" aria-hidden="true">{c.emoji}</div>
      <div class="font-semibold text-sm">{c.title}</div>
      <div class="text-xs text-muted mt-1">{c.desc}</div>
    </button>
  {/each}
</div>

<style>
  .persona-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0.9rem 0.6rem;
    border: 1px solid var(--border);
    border-radius: 0.75rem;
    background: var(--bg);
    transition: transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease;
  }
  .persona-card:hover { transform: translateY(-2px); }
  .persona-card.selected {
    border-color: rgb(99 102 241);
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
  }
  @media (prefers-reduced-motion: reduce) {
    .persona-card { transition: none; }
    .persona-card:hover { transform: none; }
  }
</style>
